function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".arrowLeft_svg__cls-1{fill:none;stroke:currentColor;stroke-width:2px}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "arrowLeft_svg__Group_390",
  "data-name": "Group 390",
  transform: "translate(.707 .707)"
}, React.createElement("path", {
  id: "arrowLeft_svg__Line_1",
  d: "M0 0l6 6",
  className: "arrowLeft_svg__cls-1",
  "data-name": "Line 1"
}), React.createElement("path", {
  id: "arrowLeft_svg__Line_3",
  d: "M0 6l6-6",
  className: "arrowLeft_svg__cls-1",
  "data-name": "Line 3",
  transform: "translate(0 5)"
}));

var SvgArrowLeft = function SvgArrowLeft(props) {
  return React.createElement("svg", _extends({
    width: 7.414,
    height: 12.414
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjQxNCIgaGVpZ2h0PSIxMi40MTQiIHZpZXdCb3g9IjAgMCA3LjQxNCAxMi40MTQiPgogICAgPGRlZnM+CiAgICAgICAgPHN0eWxlPgogICAgICAgICAgICAuY2xzLTF7ZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLXdpZHRoOjJweH0KICAgICAgICA8L3N0eWxlPgogICAgPC9kZWZzPgogICAgPGcgaWQ9Ikdyb3VwXzM5MCIgZGF0YS1uYW1lPSJHcm91cCAzOTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC43MDcgLjcwNykiPgogICAgICAgIDxwYXRoIGlkPSJMaW5lXzEiIGQ9Ik0wIDBsNiA2IiBjbGFzcz0iY2xzLTEiIGRhdGEtbmFtZT0iTGluZSAxIi8+CiAgICAgICAgPHBhdGggaWQ9IkxpbmVfMyIgZD0iTTAgNmw2LTYiIGNsYXNzPSJjbHMtMSIgZGF0YS1uYW1lPSJMaW5lIDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNSkiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgArrowLeft as ReactComponent };


//////////////////
// WEBPACK FOOTER
// /src/assets/img/arrowLeft.svg
// module id = 246
// module chunks = 0